export enum LinkAction {
  CreateLink,
  Update,
  Cancel,
}
